import { axios } from '@src/plugins/axios-pol'

export default class ReferenciaApiRepository {
  //recupera toda la referencia registrada
  async getAll() {
    const { data } = await axios.get('/personal/api/EstadoFuerza/referencias')
    return data.data
  }
  //recupera todas las referencias de un personal
  async getById(idPersonal) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/referencias`)
    return data.data
  }
  //recupera una referencia en especifico de un personal
  async getReferenciaById(idPersonal, idReferencia) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/referencias/${idReferencia}`)
    return data.data
  }
  //Crea una referencia
  async create(idPersonal, referencia) {
    const { data } = await axios.post(`/personal/api/EstadoFuerza/personal/${idPersonal}/referencias`, referencia)
    return data.data
  }
  //Actualiza una referencia
  async update(idPersonal, idReferencia, referencia) {
    const { data } = await axios.put(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/referencias/${idReferencia}`,
      referencia
    )
    return data.data
  }
  //Elimina una referencia
  async delete(idPersonal, idReferencia) {
    const { data } = await axios.put(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/referencias/${idReferencia}/vigencia`,
      {
        id: idReferencia,
        fk_idPersonal: idPersonal,
        vigente: false,
      }
    )
    return data.data
  }
  //pone vigente  una referencia
  async setVigencia(idPersonal, idReferencia) {
    const { data } = await axios.put(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/referencias/${idReferencia}/vigencia`
    )
    return data.data
  }
}
